import { Component } from '@angular/core';

@Component({
    selector: 'saf-terminal',
    templateUrl: './terminal.component.html',
    styleUrls: ['./terminal.component.scss'],
    standalone: false
})
export class TerminalComponent {}
